import * as React from 'react';
import { useState } from 'react';

import ConsumerLoggedOutHomePageHeader from 'bundles/composable-page-header-consumer/header-renderers/ConsumerLoggedOutHomePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import FrontPageCmsContent from 'bundles/front-page/components/FrontPageCmsContent';
import { FrontPageDataProvider } from 'bundles/front-page/components/FrontPageDataProvider';
import type { FrontPageDataState } from 'bundles/front-page/components/FrontPageDataProvider';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import type { FrontPageContentProps as Props } from 'bundles/front-page/types';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

type ConditionalFrontPageContentProps = FrontPageDataState & {
  isUsRegion: boolean;
  countryCode?: string;
  setHasScrolledPastHero?: (hasScrolledPastHero: boolean) => void;
  setIsMobileSearchModalOpen?: (isMobileSearchModalOpen: boolean) => void;
};

export const ConditionalFrontPageCmsContent = ({
  pageContent,
  isUsRegion,
  ...otherProps
}: ConditionalFrontPageContentProps) => {
  return pageContent ? (
    <FrontPageCmsContent {...otherProps} key="lohp-cms-content" pageContent={pageContent} isUsRegion={isUsRegion} />
  ) : null;
};

ConditionalFrontPageCmsContent.displayName = 'ConditionalFrontPageCmsContent';

const FrontPage = (props: Props) => {
  const { countryCode } = props;
  const isUsRegion = countryCode === 'us';
  const [hasScrolledPastHero, setHasScrolledPastHero] = useState(false);
  const [isMobileSearchModalOpen, setIsMobileSearchModalOpen] = useState(false);

  return (
    <React.Fragment>
      <React.Fragment>
        <ConsumerLoggedOutHomePageHeader
          hideSearchBar={!hasScrolledPastHero}
          shouldShowSearchModal={isMobileSearchModalOpen}
          setIsMobileSearchModalOpen={setIsMobileSearchModalOpen}
        />
        <UniversalPageFeatures />
      </React.Fragment>
      <FrontPageDataProvider {...props}>
        {({ pageContent, ...otherProps }: FrontPageDataState) => (
          <ConditionalFrontPageCmsContent
            pageContent={pageContent}
            isUsRegion={isUsRegion}
            countryCode={countryCode}
            setHasScrolledPastHero={setHasScrolledPastHero}
            setIsMobileSearchModalOpen={setIsMobileSearchModalOpen}
            {...otherProps}
          />
        )}
      </FrontPageDataProvider>
      <PageFooter />
      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />

      <FrontPageGoogleSchemaMarkup />
    </React.Fragment>
  );
};

export default FrontPage;
